@let blok = block();

<h3 class="blog-categories-card-heading">{{blok.title}}</h3>
@for (category of categories()?.data?.stories; track category.full_slug) {
    <a [routerLink]="category.full_slug  | sbRouterLink | cachedUrlResolver" class="blog-categories-card-link">
        {{ category.name }}
    </a>
}
